/* crude replacement to lodash's keyBy function */
export const keyBy = (collection, iteratee) => {
    if (Array.isArray(collection)) {
        return collection.reduce((acc, item) => {
            acc[item[iteratee]] = item;
            return acc;
        }, {});
    }
    if (typeof collection === 'object') {
        return Object.keys(collection).reduce((acc, key) => {
            const value = collection[key];
            acc[value[iteratee]] = value;
            return acc;
        }, {});
    }
    return collection;
};
